import React, { useContext, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import { toast } from "react-toastify";
import findBrand from "../findBrand.js";
import RegistrationContext from "../../context/registration/registrationContext";
import { brandDomains, fetchBrands } from "../brand.js";

//check formlevel

const ProgressButtons = ({ validation, name }) => {
  const registrationContext = useContext(RegistrationContext);
  const { formLevel, levelDown, levelUp, preSelected, setPass } =
    registrationContext;

  useEffect(() => {
    const loadBrands = async () => {
      await fetchBrands();
    };

    loadBrands();
  }, []);

  const brand_holston = brandDomains.brand_holston?.name;
  const brand_pbia = brandDomains.brand_pbia?.name;

  const display = () => {
    if (findBrand(brand_holston) || findBrand(brand_pbia)) {
      return (
        <div
          className="circle-btn"
          onClick={() => levelUpCheck()}
          style={{ display: formLevel === 10 ? "none" : "flex" }}
        >
          <FaIcons.FaChevronRight className="progress-level-btn" />
        </div>
      );
    } else {
      return (
        <div
          className="circle-btn"
          onClick={() => levelUpCheck()}
          style={{ display: formLevel === 14 ? "none" : "flex" }}
        >
          <FaIcons.FaChevronRight className="progress-level-btn" />
        </div>
      );
    }
  };

  const levelUpCheck = () => {
    if (validation) {
      levelUp();
      setPass(name, true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      setPass(name, false);
      toast.error("Please fill all required fields correctly.", { autoClose: 2000 });
    }
  };

  return (
    <div className="progress-btns">
      {formLevel === 15 ? (
        <div className="circle-btn-special" onClick={() => levelDown()}>
          <div className="circle-btn-diff">
            <FaIcons.FaChevronLeft className="progress-level-btn" />
          </div>
          <h3>Update previous information</h3>
        </div>
      ) : formLevel === 1 && preSelected ? (
        <></>
      ) : (
        <div
          className="circle-btn"
          style={{ display: formLevel === 0 ? "none" : "flex" }}
          onClick={() => levelDown()}
        >
          <FaIcons.FaChevronLeft className="progress-level-btn" />
        </div>
      )}

      {display()}
    </div>
  );
};

export default ProgressButtons;
